import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';
import { downloadFile } from '../../../utility/Utils';

//get All expense Forms
export const getAllProjectExpense = createAsyncThunk('expenseSlice/getAllProjectExpense', async () => {
    try {
        let response = await axios.get('/project-expense', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form by Id
export const getProjectExpensebyId = createAsyncThunk('expenseSlice/getFormbyId', async (id) => {
    try {
        let response = await axios.get(`/project-expense/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form Category Options
export const getExpenseCategoryOptions = createAsyncThunk('expenseSlice/getFormCategoryOptions', async (expenseFormId) => {
    try {
        let response = await axios.get(`/project-expense/category/options`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

//Create Machinery
export const createProjectExpense = createAsyncThunk('expenseSlice/createProjectExpense', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.post(`/project-expense`, data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Project Expense added successfully.');
        dispatch(getAllProjectExpense());

        return Promise.resolve(response.data);
    } catch (err) {
        if (err.response?.data.fields || err.response?.data?.fields) {
            toast.error(err?.response?.data?.fields[0]?.msg || 'Something went wrong!');
        }
        console.log('err1', err?.response?.data?.message);
        return rejectWithValue(err);
    }
});

// Update Project Expense
export const updateProjectExpense = createAsyncThunk('expenseSlice/updateProjectExpense', async ({ id, data }, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put(`/project-expense/${id}`, data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Project Expense updated successfully.');
        dispatch(getAllProjectExpense());

        return Promise.resolve(response.data);
    } catch (err) {
        if (err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


//Get Expense Form Items Options
export const getExpenseItemsOptions = createAsyncThunk('expenseSlice/getExpenseItemsOptions', async (params) => {
    try {

        const query = queryString.stringify(params)

        let response = await axios.get(`/item/options?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


//Edit Expense Form Category 
export const updateFormCatrogies = createAsyncThunk('expenseSlice/updateFormCatrogies', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put('/expense-form/category/' + data.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Form Categories updated successfully.');
        dispatch(getAllProjectExpense());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


//Get Expense Form Category Options
export const getMachineryOptions = createAsyncThunk('machineryTypeSlice/getMachineryOptions', async (params) => {
    try {
        const query = queryString.stringify(params)
        let response = await axios.get(`/machinery/options?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


export const deleteProjectExpense = createAsyncThunk('expenseSlice/deleteItem', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/project-expense/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Item deleted successfully.');
        await dispatch(getAllProjectExpense());

        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getMaterialOptions = createAsyncThunk('materialSlice/getMaterialOptions', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get('/material/options' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

//Upload PDF
export const uploadPDF = createAsyncThunk('expenseSlice/uploadPDF', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.post(`/project-expense/upload-file`, data, {
            // headers: {
            //     'Content-Type': 'application/json'
            // },
            loader: false
        });
        toast.success(response?.data?.message || 'Invoice PDF uploaded successfully.');
        dispatch(getAllProjectExpense());

        return Promise.resolve(response.data);
    } catch (err) {
        if (err.response?.data.fields || err.response?.data?.fields) {
            toast.error(err?.response?.data?.fields[0]?.msg || 'Something went wrong!');
        }
        return rejectWithValue(err);
    }
});

//Download Excel
export const downloadExcel = createAsyncThunk('expenseSlice/downloadExcel', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.post(`/project-expense/download-excel`, data, {
            responseType: 'blob',
            loader: true
        });
        downloadFile(response, 'Expense Excel')

        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.message || 'Project Expense data not found');
        return rejectWithValue(err);
    }
});

export const getMessItemOptions = createAsyncThunk('materialSlice/getMessItemOptions', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get('/item/mess-and-transportation/options' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const expenseSlice = createSlice({
    name: 'expenseSlice',
    initialState: {
        data: [],
        selectedProjectExpsense: {},
        formData: {}
    },
    extraReducers: (builder) => {
        builder.addCase(getAllProjectExpense.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getProjectExpensebyId.fulfilled, (state, action) => {
            state.selectedProjectExpsense = action?.payload;
            return;
        });
        // builder.addCase(getFormbyId.fulfilled, (state, action) => {
        //     state.formData = action?.payload;
        //     return;
        // });
    }
});

export default expenseSlice.reducer;
